var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"tw-p-4 tw-align-baseline first:tw-pl-0 last:tw-pr-0 last:tw-text-right"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }